<template>
  <div
    v-if="pageLoading"
    class="m-3"
  >
    <placeholder-content :is-load="true" />
  </div>
  <div
    v-else-if="!hasPermission"
    class="m-3"
  >
    <access-denied/>
  </div>
  <div
    v-else
  >
    <div class="d-flex justify-content-between border-bottom mb-3">
      <ul class="nav nav-custom">
        <li class="nav-item">
          <a class="nav-link active">
            {{ $t('All') }}
            <span class="badge rounded-pill bg-primary">
              {{ datatable.total }}
            </span>
          </a>
        </li>
      </ul>
    </div>
    <div class="d-flex justify-content-start mx-3 flex-column flex-sm-row">
      <div class="custom-input-group custom-input-group input-group input-group-sm me-sm-2 mb-3 w-auto">
        <input
          type="search"
          class="form-control"
          :placeholder="$t('search')+'...'"
          aria-label="Search"
          aria-describedby="search-addon"
          v-model.trim="params.search"
          @keyup.enter="fetchData"
        >
        <button
          class="input-group-text bg-white text-muted"
          type="button"
          @click="fetchData"
        >
          <i class="fas fa-search" />
        </button>
      </div>
      <per-page
        @per-page="setPerPage"
      />
    </div>
    <vue3-easy-data-table
      v-model:server-options="datatable.serverOptions"
      ref="dataTable"
      :headers="datatable.headers($t)"
      :items="datatable.items"
      :loading="datatable.loading"
      :server-items-length="datatable.total"
      :theme-color="'#515151'"
      :hide-footer="false"
      :hide-rows-per-page="true"
      :empty-message="$t('No Available Data')"
      :table-min-height="null"
      buttons-pagination
      :body-item-class-name="bodyItemClassNameFunction"
      table-class-name='customize-table'
    >
      <template #header-created_by="header">
        <span class="w-100 text-end">
          {{ header.text }}
        </span>
      </template>
      <template #item-name="item">
        {{ $t(item.name) }}
      </template>
      <template #item-status="item">
        <span v-if="item.status == 'Open'" class="badge bg-success">
          <i class="fas fa-check-circle me-1" />
          {{ $t(item.status) }}
        </span>
        <span v-else class="badge bg-danger">
          <i class="fas fa-times-circle me-1" />
          {{ $t(item.status) }}
        </span>
      </template>
      <template #item-shift="item">
        {{ item.status == 'Open'? (item.shift_user + ' ('+ dateDistance(item.started_at) +')'): '-' }}
      </template>
      <template #item-action="item">
        <div
          class="icon-link custom-actions"
          v-if="item.status == 'Open'"
        >
          <popper
            :placement="'top'"
            :hover="true"
            :arrow="true"
            :disableClickAway="true"
            class="popper-default border-0 m-0"
            @click="enterShop(item.id)"
          >
            <button
              type="button"
              data-bs-toggle="popover"
              data-bs-placement="top"
              class="btn btn-success btn-sm btn-icon"
            >
              <i class="fa-solid fa-arrow-right" />
            </button>
            <template #content>
              <div>{{ $t('Enter Shop') }}</div>
            </template>
          </popper>
          <popper
            :placement="'top'"
            :hover="true"
            :arrow="true"
            :disableClickAway="true"
            class="popper-default border-0 m-0"
          >
            <button
              type="button"
              data-bs-toggle="popover"
              data-bs-placement="top"
              data-bs-title="Custom popover"
              data-bs-content="This popover is themed via CSS variables."
              class="btn btn-outline-secondary btn-sm btn-icon"
              @click="() => {
                offcanvasShiftInfo.open = true;
                offcanvasShiftInfo.id = item.shift_id;
              }"
            >
              <i class="fa-solid fa-info-circle" />
            </button>
            <template #content>
              <div>{{ $t('Details') }}</div>
            </template>
          </popper>
          <popper
            :placement="'top'"
            :hover="true"
            :arrow="true"
            :disableClickAway="true"
            class="popper-default border-0 m-0"
          >
            <button
              type="button"
              data-bs-toggle="popover"
              data-bs-placement="top"
              data-bs-title="Custom popover"
              data-bs-content="This popover is themed via CSS variables."
              class="btn btn-danger btn-sm btn-icon"
              @click="() => {
                offcanvasFinalizeCloseShiftForm.open = true;
                offcanvasFinalizeCloseShiftForm.id = item.shift_id;
              }"
            >
              <i class="fa-solid fa-house-lock" />
            </button>
            <template #content>
              <div>{{ $t('Close') }}</div>
            </template>
          </popper>
        </div>
        <div
          class="icon-link custom-actions"
          v-else
        >
          <popper
            :placement="'top'"
            :hover="true"
            :arrow="true"
            :disableClickAway="true"
            class="popper-default border-0 m-0"
          >
            <button
              type="button"
              data-bs-toggle="popover"
              data-bs-placement="top"
              data-bs-title="Custom popover"
              data-bs-content="This popover is themed via CSS variables."
              class="btn btn-primary btn-sm btn-icon"
              @click="() => {
                offcanvasOpenShiftForm.open = true;
                offcanvasOpenShiftForm.id = item.id;
              }"
            >
              <i class="fa-solid fa-plus" />
            </button>
            <template #content>
              <div>{{ $t('Open Shift') }}</div>
            </template>
          </popper>
        </div>
      </template>
      <template #loading>
        <i class="fa-solid fa-spinner fa-spin fa-2xl" />
      </template>
    </vue3-easy-data-table>
    <offcanvas-open-shift-form
      v-if="offcanvasOpenShiftForm.open"
      :id="offcanvasOpenShiftForm.id"
    />
    <offcanvas-shift-info
      v-if="offcanvasShiftInfo.open"
      :id="offcanvasShiftInfo.id"
      @close="() => {
        offcanvasShiftInfo.open = false;
      }"
      @openFinalizeCloseShift="() => {
        offcanvasFinalizeCloseShiftForm.open = true;
        offcanvasFinalizeCloseShiftForm.id = offcanvasShiftInfo.id;
      }"
    />
    <offcanvas-finalize-close-shift-form
      v-if="offcanvasFinalizeCloseShiftForm.open"
      :id="offcanvasFinalizeCloseShiftForm.id"
      @close="() => {
        offcanvasFinalizeCloseShiftForm.open = false;
      }"
      @openShiftInfo="() => {
        offcanvasShiftInfo.open = true;
        offcanvasShiftInfo.id = offcanvasFinalizeCloseShiftForm.id;
      }"
    />
  </div>
</template>
<script lang="js">
import Vue3EasyDataTable from 'vue3-easy-data-table';
import PlaceholderContent from '@/plugins/PlaceholderContent.vue';
import AccessDenied from "@/plugins/AccessDenied.vue";
import PerPage from '@/plugins/PerPage.vue';
import FieldsDef from "./assets/template/datatable/FieldsDef";
import OffcanvasOpenShiftForm from './OffcanvasOpenShiftForm.vue';
import OffcanvasFinalizeCloseShiftForm from './OffcanvasFinalizeCloseShiftForm.vue';
import OffcanvasShiftInfo from './OffcanvasShiftInfo.vue';
import { POSRegisters } from '@/services/endpoint/pos.service';
import { useShopStore } from '@/stores/shop.store';
import moment from "moment";
import numeral from 'numeral';
import Popper from "vue3-popper";
import { distance } from '@/store/date-fns';

export default {
  data() {
    return {
      params: {
        limit: 10,
        page: 1,
        search: ''
      },
      pageLoading: false,
      hasPermission: false,
      datatable: {
        loading: false,
        headers: FieldsDef,
        items: [],
        total: 0,
        serverOptions: {
          page: 1,
          rowsPerPage: 10
        }
      },
      offcanvasShiftInfo: {
        open: false,
        id: 0
      },
      offcanvasFinalizeCloseShiftForm: {
        open: false,
        id: 0
      },
      offcanvasOpenShiftForm: {
        open: false,
        id: 0
      },
    }
  },
  components: {
    PlaceholderContent,
    AccessDenied,
    PerPage,
    Vue3EasyDataTable,
    OffcanvasOpenShiftForm,
    OffcanvasFinalizeCloseShiftForm,
    OffcanvasShiftInfo,
    Popper
  },
  async mounted() {
    this.pageLoading = true;
    await this.fetchData();
    this.pageLoading = false;
  },
  methods: {
    enterShop(id) {
      try {
        let self = this;
        let title = this.$t("Enter Shop Mode") + '?';
        let html = this.$t("You will be redirected to the POS and Floor Plan.");
        let confirmButtonText =
          '<i class="fa-solid fa-store me-1"></i>' + this.$t("Enter Shop");
        this.$swal({
          icon: "question",
          iconColor: "#FF7043",
          title: title,
          // text: "You will not be able to undo this action.",
          html: html,
          showCancelButton: true,
          cancelButtonText: this.$t("Cancel"),
          confirmButtonText: confirmButtonText,
          buttonsStyling: false,
          customClass: {
            confirmButton: "btn btn-primary",
            cancelButton: "btn btn-danger me-2",
          },
          focusConfirm: false,
          showLoaderOnConfirm: true,
          reverseButtons: true,
          preConfirm: async function () {
            return useShopStore().enterShop(id).then(function(data) {
              self.$router.push({ name: 'pos.table' });
            }).catch(err => {
              if (err?.response?.status === 403) {
                self.$swal.update({
                  title: self.$t('Access Denied'),
                  confirmButtonText: '<i class="fas fa-redo me-1"></i>' + self.$t("Try again"),
                  text: self.$t('You do not have permission to access this page.')
                });
                self.$swal.showValidationMessage(
                  self.$t(err?.response?.data?.message)
                )
              } else {
                self.$toast.warn(self.$t(err?.response?.data?.message || 'Failed'));
              }
            });
          },
        });
      } catch (error) {
        console.log(error);
      }
    },
    dateDistance(value) {
      return distance(value);
    },
    bodyItemClassNameFunction(column, rowNumber) {
      let className = 'align-top py-1 px-2';
      const columnCenter = [];
      const columnEnd = ['options_count', 'created_by'];
      if (columnCenter.includes(column)) {
        className += ' text-center';
      }
      if (columnEnd.includes(column)) {
        className += ' text-end';
      }
      return className;
    },
    async fetchData() {
      this.datatable.loading = true;
      var queryString = '?' + $.param(this.params);
      await POSRegisters.list(queryString).then(res => {
        this.datatable.items = res.data.data;
        this.datatable.total = res.data.meta.total;
        this.hasPermission = true;
      }).catch(err => {
        if (err?.response?.status === 403) {
          this.hasPermission = false;
        }
      });

      this.datatable.loading = false;
      return;
    },
    setPerPage(perPage) {
      this.params.limit = perPage;
      this.$refs.dataTable.updateRowsPerPageActiveOption(perPage);
      this.fetchData();
    },
    formatDateTime(value) {
      return moment(value).format('YYYY-MM-DD HH:mm:ss');
    },
    formatTimeNotSec(value) {
      return moment(value).format('HH:mm');
    },
    formatNumberDigit(value) {
      return numeral(value).format("0,0.00");
    },
    formatNumber(value) {
      return numeral(value).format("0,0");
    },
  },
  watch: {
    "datatable.serverOptions" (nval, oval) {
      delete this.params.sort;
      this.params.page = nval.page;
      this.params.limit = nval.rowsPerPage;
      if (nval.sortBy && nval.sortType) this.params.sort = nval.sortBy + "|" + nval.sortType;
      this.fetchData();
    }
  }
}
</script>
